import React, { useState } from "react";
import { DatePicker, Select, Space, TimePicker } from "antd";

export default function PeriodRangePicker({ value, onChange }) {
    const period = value.period?.toLowerCase();
    return (
        <Space.Compact>
            <Select
                aria-label="Picker Type"
                style={{ width: 120 }}
                value={value.period}
                onChange={(period) =>
                    onChange({
                        interval: [
                            value.interval[0].startOf(period),
                            value.interval[1].endOf(period),
                        ],
                        period,
                    })
                }
                options={[
                    { label: "Mensile", value: "MONTH" },
                    { label: "Trimestrale", value: "QUARTER" },
                    { label: "Annuale", value: "YEAR" },
                ]}
            />
            <DatePicker.RangePicker
                value={value.interval}
                style={{ width: 250 }}
                format={{ month: "MMM-YYYY", year: "YYYY", quarter: `[Q]Q-YYYY` }[period]}
                picker={period}
                allowClear={false}
                onChange={(interval) =>
                    onChange({
                        ...value,
                        interval: [interval[0].startOf(period), interval[1].endOf(period)],
                    })
                }
            />
        </Space.Compact>
    );
}
